import React, { Component } from 'react';
import { noop } from '../../../utils';
import { black } from 'material-ui/styles/colors';
import QueryBuilder from 'material-ui/svg-icons/action/query-builder';
import DatePickerDialog from './DateTimeDialog';
import ReactInputMask from 'react-input-mask';
import { isUndefined } from 'lodash';
import PropTypes from 'prop-types';
import * as moment from 'moment';

import 'intl';

export const format = value => {
  const days = value.getDate() > 9 ? value.getDate() : `0${value.getDate()}`;
  const months = value.getMonth() + 1 > 9 ? value.getMonth() + 1 : `0${value.getMonth() + 1}`;
  const hours = value.getHours() > 9 ? value.getHours() : `0${value.getHours()}`;
  const minutes = value.getMinutes() > 9 ? value.getMinutes() : `0${value.getMinutes()}`;
  return `${value.getFullYear()}-${months}-${days}T${hours}:${minutes}`;
};

class DateTimePicker extends Component {
  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  static defaultProps = {
    label: '',
    onChange: noop,
    DateTimeFormat: global.Intl.DateTimeFormat, // TODO check for safari int support ^_^
    type: 'text',
    disabled: false,
    autoOk: false,
    locale: 'cs-CZ',
    timeFormat: '24hr',
    container: 'dialog',
    disableYearSelection: false,
    firstDayOfWeek: 1,
    dateOnly: true,
    textFieldStyle: {},
    noIcon: false,
    help: false
  };

  state = {
    date: undefined,
    text: ''
  };

  componentWillMount() {
    const date = this.getControlledDate();
    this.setState({
      date,
      text: date ? this.formatDate(date) : ''
    });
  }

  componentWillReceiveProps(nextProps) {
    // while the user types, every onChange comes straight back as props -
    // resyncing the text mid-edit would overwrite unfinished input
    if (this.editing) {
      return;
    }
    const date = this.getControlledDate(nextProps);
    this.setState({
      date,
      text: date ? this.formatDate(date) : ''
    });
  }

  handleFocus = () => {
    this.editing = true;
  };

  handleBlur = () => {
    this.editing = false;
    // editing done - show the canonical form of whatever value survived
    const date = this.getControlledDate();
    this.setState({
      date,
      text: date ? this.formatDate(date) : ''
    });
  };

  getControlledDate = (props = this.props) => {
    if (props.value instanceof Date) {
      return props.value;
    }
    return undefined;
  };

  getDate() {
    return this.state.date;
  }

  handleAccept = (date) => {
    if (this.props.onChange) {
      this.setState({ date, text: this.formatDate(date) });
      this.props.onChange(date);
    }
  };

  openDialog = () => {
    if (this.state.date !== undefined) {
      this.setState({
        dialogDate: this.getDate()
      }, this.refs.dialogWindow.show);
    } else {
      this.setState({
        dialogDate: new Date()
      }, this.refs.dialogWindow.show);
    }
  };

  formatDate = (date) => {
    // moment formats in local time - the previous manual UTC shift moved
    // late-evening dates to the next day
    return moment(date).format('DD.MM.YYYY HH:mm');
  };

  handleOpen = () => {
    const { disabled } = this.props;
    if (!disabled) {
      this.openDialog();
    }
  };

  handleChange = (e) => {
    const value = e.target.value;
    const { onChange } = this.props;

    // The mask fills unfinished positions with underscores. Anything not fully
    // typed (missing date digits, half-typed time) must never fire or clear the
    // filter - the time only counts once both hh and mm are complete, otherwise
    // the value is the bare date at midnight.
    const raw = value.replace(/_/g, '');

    if (raw.replace(/[.:\s]/g, '') === '') {
      this.setState({ date: undefined, text: '' })
      onChange('');
      return
    }

    const data = raw.match(/^(\d{2})\.(\d{2})\.(\d{4})/);
    if (data === null) {
      // date not finished typing - keep the previous filter value
      this.setState({ date: undefined, text: value });
      return
    }

    const day = +data[1];
    const month = +data[2];
    const year = +data[3];
    const timeMatch = raw.match(/\s(\d{2}):(\d{2})$/);
    // out-of-range time (60:00) clamps to the max instead of clearing the typed date
    const hours = timeMatch ? Math.min(+timeMatch[1], 23) : 0;
    const minutes = timeMatch ? Math.min(+timeMatch[2], 59) : 0;
    const date = new Date(year, month - 1, day, hours, minutes);
    const valid = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
    this.setState({ date: valid ? date : undefined, text: value });
    if (valid) {
      onChange(date);
    } else {
      // fully typed but impossible date (31.02.) -> clear
      onChange('');
    }
  };

  render() {
    const {
      label,
      style, // eslint-disable-line no-unused-vars
      name,
      disabled,
      DateTimeFormat,
      autoOk,
      cancelLabel,
      className,
      container,
      defaultDate, // eslint-disable-line no-unused-vars
      dialogContainerStyle,
      disableYearSelection,
      errorText,
      firstDayOfWeek,
      formatDate: formatDateProp, // eslint-disable-line no-unused-vars
      locale,
      maxDate,
      minDate,
      mode,
      okLabel,
      onDismiss,
      onFocus, // eslint-disable-line no-unused-vars
      onKeyDown,
      onShow,
      onTouchTap, // eslint-disable-line no-unused-vars
      shouldDisableDate,
      timeFormat,
      value, // eslint-disable-line no-unused-vars
      textFieldStyle, // eslint-disable-line no-unused-vars
      dateOnly,
      fullWidth,
      noIcon,
      helpEnum,
      inputProps,
    } = this.props;

    const inputPlaceHolder = dateOnly ? 'dd.mm.rrrr' : 'dd.mm.rrrr --:--'
    const inputMask = dateOnly ? '99.99.9999' : '99.99.9999 99:99'
    return (
      <div className={`datetimeControl${fullWidth ? ' datetimeControl--fullWidth' : ''}`}>
        <div>
          <DatePickerDialog
            dateOnly={dateOnly}
            DateTimeFormat={DateTimeFormat}
            autoOk={autoOk}
            cancelLabel={cancelLabel}
            container={container}
            containerStyle={dialogContainerStyle}
            disableYearSelection={disableYearSelection}
            firstDayOfWeek={firstDayOfWeek}
            initialDate={this.state.dialogDate}
            locale={locale}
            maxDate={maxDate}
            minDate={minDate}
            mode={mode}
            okLabel={okLabel}
            onAccept={this.handleAccept}
            onShow={onShow}
            onDismiss={onDismiss}
            ref="dialogWindow"
            shouldDisableDate={shouldDisableDate}
            timeFormat={timeFormat}
          />
        </div>
        <div className={`container${!isUndefined(helpEnum) ? ' container--with-help' : ''}`}>
          <div className={`croField${errorText ? ' croField--error' : ''}`}>
            <ReactInputMask
              mask={inputMask}
              placeholder={inputPlaceHolder}
              value={this.state.text}
              onChange={this.handleChange}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              onKeyDown={onKeyDown}
              name={name}
              disabled={disabled}
              className={`croField__input${className ? ` ${className}` : ''}`}
              aria-label={inputProps?.['aria-label'] ?? 'Hodnota'}
              autocomplete="off"
            />
            {errorText && <span className="croField__errorText">{errorText}</span>}
          </div>
          {!noIcon && !disabled && <QueryBuilder className="trigger" color={black} onClick={this.handleOpen} />}
        </div>
      </div>
    );
  }
}

export default DateTimePicker;
